var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpApiRequest } from "./http-api-request.js";
export function getApps(config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpApiRequest(`v5/apps`, config).setMethod('GET').fetch();
        if (response.data == null) {
            return [];
        }
        let appListPlain = response.data;
        let appsJson = appListPlain.items;
        if (appsJson == null) {
            return [];
        }
        return appsJson;
    });
}
export function getApp(id, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpApiRequest(`v5/apps/${id}`, config).setMethod('GET').fetch();
        return response.data;
    });
}
export function createApp(app, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpApiRequest(`v5/apps`, config).setMethod('POST').setPayload(app).fetch();
        return response.data;
    });
}
export function updateApp(app, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpApiRequest(`v5/apps`, config).setMethod('PUT').setPayload(app).fetch();
        return response.data;
    });
}
//# sourceMappingURL=app-service.js.map